import React, { useState, useEffect } from "react";
import { useCart } from "../context/CartContext";
import { useNavigate } from "react-router-dom";

export default function Checkout() {
  const { cart } = useCart();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    postalCode: "",
  });

  // Auto-fill name & email from user login
  useEffect(() => {
    const savedName = localStorage.getItem("userName");
    const savedEmail = localStorage.getItem("userEmail");

    setForm((prev) => ({
      ...prev,
      name: savedName || "",
      email: savedEmail || "",
    }));
  }, []);

  // If cart is empty → redirect to cart
  useEffect(() => {
    if (cart.length === 0) {
      navigate("/cart");
    }
  }, [cart, navigate]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleCheckout = () => {
    // Required fields
    if (!form.name || !form.address || !form.city || !form.postalCode) {
      alert("Please complete your shipping address.");
      return;
    }

    // Save for Order Summary
    localStorage.setItem("shippingInfo", JSON.stringify(form));

    navigate("/order-summary");
  };

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Shipping Address</h1>

      <div className="space-y-4 bg-white p-6 rounded-xl shadow">
        <input
          name="name"
          placeholder="Full Name"
          value={form.name}
          onChange={handleChange}
          className="border rounded-lg p-2 w-full"
        />

        <input
          name="email"
          placeholder="Email"
          type="email"
          value={form.email}
          onChange={handleChange}
          className="border rounded-lg p-2 w-full"
        />

        <input
          name="phone"
          placeholder="Phone Number"
          value={form.phone}
          onChange={handleChange}
          className="border rounded-lg p-2 w-full"
        />

        <textarea
          name="address"
          placeholder="Street Address"
          value={form.address}
          onChange={handleChange}
          className="border rounded-lg p-2 w-full"
        />

        <div className="flex gap-4">
          <input
            name="city"
            placeholder="City"
            value={form.city}
            onChange={handleChange}
            className="border rounded-lg p-2 w-full"
          />

          <input
            name="postalCode"
            placeholder="Postal Code"
            value={form.postalCode}
            onChange={handleChange}
            className="border rounded-lg p-2 w-full"
          />
        </div>

        <button
          onClick={handleCheckout}
          className="w-full bg-black text-white py-3 rounded-lg text-lg hover:bg-gray-800"
        >
          Continue to Order Summary
        </button>
      </div>
    </div>
  );
}
